module.exports = __webpack_public_path__ + "img/product_01.42155d14.jpg";